var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import Autosuggest from 'react-autosuggest';
import { withFormsy } from 'formsy-react';
import debounce from 'lodash.debounce';
import { autosuggestTheme } from './style';
import Input from '../Input';
var AutosuggestInput = (function (_super) {
    __extends(AutosuggestInput, _super);
    function AutosuggestInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            value: _this.props.value || ''
        };
        _this.componentDidUpdate = function (prevProps) {
            if (_this.props.value !== prevProps.value) {
                _this.setState({ value: _this.props.value || '' });
                if (_this.props.setValue) {
                    _this.props.setValue(_this.props.value || '');
                }
            }
        };
        _this.onChange = function (event, _a) {
            var newValue = _a.newValue, method = _a.method;
            _this.setState({ value: newValue });
            if (_this.props.setValue) {
                _this.props.setValue(newValue);
            }
            if (_this.props.onChange) {
                _this.props.onChange(event, { newValue: newValue, method: method });
            }
        };
        _this.onSuggestionSelected = function (event, suggestion) {
            event.preventDefault();
            _this.props.onSuggestionSelected &&
                _this.props.onSuggestionSelected(event, suggestion);
        };
        _this.debounceFetch = debounce(_this.props.onSuggestionsFetchRequested, 250);
        _this.render = function () {
            var inputProps = {
                onChange: _this.onChange,
                value: _this.state.value,
                'data-test-id': _this.props['data-test-id']
            };
            var _a = _this.props.theme, overrideTheme = _a === void 0 ? {} : _a;
            var theme = {
                container: __assign(__assign({}, autosuggestTheme.container), overrideTheme.container),
                suggestionsContainer: __assign(__assign({}, autosuggestTheme.suggestionsContainer), overrideTheme.suggestionsContainer),
                suggestionsContainerOpen: __assign(__assign({}, autosuggestTheme.suggestionsContainerOpen), overrideTheme.suggestionsContainerOpen),
                suggestionsList: __assign(__assign({}, autosuggestTheme.suggestionsList), overrideTheme.suggestionsList),
                suggestion: __assign(__assign({}, autosuggestTheme.suggestion), overrideTheme.suggestion),
                suggestionHighlighted: __assign(__assign({}, autosuggestTheme.suggestionHighlighted), overrideTheme.suggestionHighlighted)
            };
            return (_jsx(Autosuggest, { theme: theme, renderInputComponent: function (props) {
                    return _this.props.input ? (React.cloneElement(_this.props.input, props)) : (_jsx(Input, { ref: undefined, input: props, value: props.value, name: _this.props.name, requiredFeedbackTestId: _this.props.requiredFeedbackTestId, required: _this.props.required }));
                }, suggestions: _this.props.suggestions, focusInputOnSuggestionClick: _this.props.focusInputOnSuggestionClick, onSuggestionSelected: _this.onSuggestionSelected, onSuggestionsFetchRequested: _this.debounceFetch, onSuggestionsClearRequested: _this.props.clearSuggestions, getSuggestionValue: _this.props.getSuggestionValue, renderSuggestion: _this.props.renderSuggestion, inputProps: inputProps, multiSection: _this.props.multiSection, renderSectionTitle: _this.props.renderSectionTitle, getSectionSuggestions: _this.props.getSectionSuggestions }));
        };
        return _this;
    }
    return AutosuggestInput;
}(React.Component));
export default AutosuggestInput;
export var AutosuggestInputWithFormsy = withFormsy(AutosuggestInput);
//# sourceMappingURL=index.js.map